import { ABOUT } from "@/data/content";
import { Reveal, SectionHead } from "@/components/Reveal";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="section-pad bg-paper">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-6">
          <SectionHead eyebrow={ABOUT.eyebrow} title={ABOUT.title} />
          <div className="mt-8 max-w-xl md:mt-12">
            <Reveal delay={0.1}>
              <p className="text-body-sm text-ink/65 md:text-body">{ABOUT.paragraphs[0]}</p>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-5 text-body-sm text-ink/65 md:text-body">{ABOUT.listIntro}</p>
            </Reveal>
            <Reveal delay={0.22}>
              <ul className="mt-4 list-disc space-y-2.5 pl-5 text-body-sm font-semibold text-ink md:text-body">
                {ABOUT.domains.map((d) => (
                  <li key={d}>{d}</li>
                ))}
              </ul>
            </Reveal>
            <Reveal delay={0.28}>
              <p className="mt-6 text-body-sm text-ink/65 md:text-body">{ABOUT.closing}</p>
            </Reveal>
          </div>
          <div className="mt-10 max-w-xl hairline-t border-line">
            {ABOUT.features.map((f, i) => (
              <Reveal key={f.title} delay={0.1 + i * 0.05}>
                <div className="hairline-b border-line py-5" data-testid={`about-feature-${i + 1}`}>
                  <h3 className="font-display text-base font-semibold">{f.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-ink/60">{f.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <div className="lg:col-span-6">
          <Reveal delay={0.15} className="relative lg:sticky lg:top-28">
            <div className="overflow-hidden rounded-3xl border border-line shadow-[0_48px_90px_-48px_rgba(11,25,44,0.35)]">
              <img
                src={ABOUT.image}
                srcSet={`${ABOUT.image} 768w, ${ABOUT.image2x} 1536w`}
                sizes="(min-width: 1024px) 590px, 100vw"
                width="1536"
                height="1024"
                alt={ABOUT.imageAlt}
                loading="lazy"
                className="h-auto w-full"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
